import {Component, h, Fragment} from "preact";
import {useEffect, useState} from "preact/hooks";
import {Link} from "react-router-dom";
import {t} from "../../_i18n";
import {C, E} from "../layout";

type valuesTypes = {
    name: string,
    desc: string,
    translate: string
}

const DropdownButton = (props:any) => {
    const [ shown, setShown ] = useState(true);
    const [ status, setStatus] = useState(props.initialStatus)

    useEffect(() => {
        function docClick(event:any) {
            if (event.path && event.path.filter((ele:any) => ele.id === 'label-menu-left').length > 0)
                return;
            if (!shown) {
                setShown(true)
            }
        }
        document.addEventListener("click", docClick);
        return () => {
            document.removeEventListener("click", docClick);
        };
    }, [shown]);

    return <section className={`dropdown ${props.className}`}>
        <div className="dropdown-element dropdown-area">
            <div className='dropdown-selector'>
                <div className='dropdown-button'>
                    <div className='dropdown-button__text' onClick={() => props.onClick(status)}>
                        {t(props.values[status].translate)}
                    </div>
                    <div className='dropdown-button__icon' onClick={() => setShown(!shown)} id="dropdown" >
                        <i className="far fa-chevron-down" />
                    </div>
                </div>
            </div>
            {!shown && <article className={`menu-handler ${props.isMobile ? 'dropdown-button__menu-mobile' : 'dropdown-button__menu'}`}>
                <div className='m-top m-bottom'>
                    {Object.keys(props.values).map((key: string, index: number) => <div >
                        <E className='m-lr flexrow cursor-pointer'  onClick={() => setStatus(props.values[key].name)}>
                            <span className='col-10'>{(props.values[key].name === status) && <i className="fal fa-check dropdown-button__icon_checked" />}</span>
                            <span className={'col-90 d-flex flex-column'}>
                                <span className={"font-medium"}>{t(props.values[key].translate)}</span>
                                <span className='m-top font-small font-light'>{(props.values[key].desc)}</span>
                            </span>
                        </E>

                        {(Object.values(props.values).length > 0 && Object.values((props.values)).length - 1 !== index) && <hr className="separator-xxs"/>}
                    </div>)}
                </div>
            </article>}
        </div>
    </section>


};

export default DropdownButton;
